import React from 'react';
import { useFeatures } from '../../contexts/FeaturesContext';

const NoAccessMessage = () => {
  const { user } = useFeatures();
  console.log(user, 'NoAccessMessage');

  if (user?.roles && user?.roles.length === 0) {
    return (
      <div className="container-fluid p-3">
        <div className="text-center bg-light rounded border p-4">
          <div className="display-4 text-muted mb-3">👤</div>

          <h4 className="text-dark mb-2 fw-semibold">No Roles Assigned </h4>

          <p className="text-muted mb-3 small">
            Sorry! No roles have been assigned to you yet. Please contact the IT team to get access. 
          </p>
        

          <div className="bg-info bg-opacity-10 border border-info rounded p-2 mb-2">
            <div className="d-flex align-items-center justify-content-center mb-1">
              <span className="me-1">💡</span>
              <strong className="text-primary small">Need Help?</strong>
            </div>
            <p className="text-primary mb-2 small">
              Contact IT support to request role assignment
            </p>
            <a 
              href="https://docs.google.com/document/d/15MdeeoS2-dy-TX8vMDCZ0pIOU-X5lHrxXEHyKEbqX3g/edit?tab=t.0#heading=h.9vzq1gb7f0b" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-inline-flex align-items-center text-decoration-none text-primary small fw-semibold"
              style={{
                transition: 'all 0.2s ease',
                padding: '6px 12px',
                borderRadius: '4px',
                border: '1px solid #0d6efd',
                backgroundColor: 'rgba(13, 110, 253, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(13, 110, 253, 0.2)';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(13, 110, 253, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <i className="fa fa-book me-2" aria-hidden="true"></i>
              <span>Read more about roles and permissions</span>
              <i className="fa fa-external-link ms-2" aria-hidden="true" style={{ fontSize: '0.85em' }}></i>
            </a>
          </div>

          <div className="text-muted small fst-italic">
            Role assignments are processed within 1-2 hours
          </div>
        </div>
      </div>
    );
  }
  return (
    <div> <div className="container-fluid p-3">
      <div className="text-center bg-light rounded border p-4">
        <div className="display-4 text-muted mb-3">🔒</div>

        <h4 className="text-dark mb-2 fw-semibold">No Access to Features</h4>

        <p className="text-muted mb-3 small">
          Follow these steps to request access:
        </p>

        <div className="bg-white rounded border p-3 mb-3">
          <div className="mb-2">
            <div className="flex align-items-center p-2 bg-light rounded mb-2">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: '20px', height: '20px', fontSize: '10px', fontWeight: 'bold' }}>
                1
              </div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <strong className="text-dark small">Your roles</strong>
                <div className="text-muted small">{user?.roles?.map((role) => role?.role).join(', ')}</div>
              </div>
            </div>

            <div className="flex align-items-center p-2 bg-light rounded  mb-2">
              <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: '20px', height: '20px', fontSize: '10px', fontWeight: 'bold' }}>
                2
              </div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <strong className="text-dark small">Raise JIRA ticket to IT team</strong>
                <a href="hhttps://meesho.atlassian.net/servicedesk/customer/portal/23/group/205/create/600" target="_blank" rel="noopener noreferrer">
                  <span className="text-primary small">Click here</span>
                </a>
              </div>
            </div>

            <div className="flex align-items-center p-2 bg-light rounded">
              <div className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: '20px', height: '20px', fontSize: '10px', fontWeight: 'bold' }}>
                3
              </div>
              <div>
                <strong className="text-dark small">Take permission from your manager</strong>
              </div>
            </div>
          </div>
        </div>
        <div className="flex align-items-center p-2 bg-light rounded">
          <div className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{ width: '20px', height: '20px', fontSize: '10px', fontWeight: 'bold' }}>
            3
          </div>
          <div>
            <strong className="text-dark small">Take permission from your manager</strong>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-info bg-opacity-10 border border-info rounded p-2 mb-2">
      <div className="d-flex align-items-center justify-content-center mb-1">
        <span className="me-1">💡</span>
        <strong className="text-primary small">Need Help?</strong>
      </div>
      <p className="text-primary mb-0 small">
          Contact IT support for assistance
      </p>
    </div>

    <div className="text-muted small fst-italic">
        Access requests processed within 1-2 business days
    </div>
    </div >
  );
};

export default NoAccessMessage;
